import styled, { css } from 'styled-components';

export const OptionWrapper = styled.div<{ isSelected: boolean; number: number }>`
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  display: flex;
  width: 48px;
  height: 48px;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  cursor: pointer;

  ${({ isSelected, number, theme }) => {
    const getColorSet = () => {
      if (number <= 6) return 'red';
      if (number >= 9) return 'green';
      return 'orange';
    };

    const colorSet = getColorSet();

    return css`
      color: ${theme.colors[`${colorSet}7`]};
      border-color: ${theme.colors[`${colorSet}${isSelected ? '7' : '4'}`]};
      background-color: ${isSelected ? theme.colors[`${colorSet}1`] : 'transparent'};

      &:hover {
        background-color: ${theme.colors[`${colorSet}1`]};
      }
    `;
  }}
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    align-items: flex-start;
    flex-wrap: nowrap;
    justify-content: none;
  }
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
`;
